import type { ReactNode } from "react";

interface FormFieldProps {
  label?: string;
  tooltip?: string;
  children: ReactNode;
  className?: string;
  inline?: boolean;
  warning?: string | null;
}

export default function FormField({
  label,
  tooltip,
  children,
  className = "",
  inline = true,
  warning = null,
}: FormFieldProps) {
  return (
    <div className={`${inline ? "inline-block" : "block"} ${className}`}>
      <label className="inline-block">
        {label && (
          <span className="relative inline-block group hover:cursor-pointer hover:border-b-2 hover:border-[#DDA248]">
            {label}:
            {tooltip && (
              <div className="absolute z-20 invisible group-hover:visible bg-[#DDA248] text-white text-xs rounded p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-48 max-w-[calc(100vw-2rem)] sm:w-64 sm:max-w-none bottom-[calc(100%+8px)] left-1/2 -translate-x-1/2 pointer-events-none">
                {tooltip}
                <div className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-8 border-t-[#DDA248]"></div>
              </div>
            )}
          </span>
        )}
        {children}
      </label>
      {warning && <div className="text-red-500 text-sm mt-1">{warning}</div>}
    </div>
  );
}
